import { Component, Output, Input, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'playbook-admin-page-header',
  templateUrl: 'admin-page-header.component.html',
  styleUrls: ['./admin-page-header.component.scss'],
})
export class AdminPageHeaderComponent {}
